import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { hasError, validateAWBPrefix, removeError } from '../CaptureAWB/captureAwbUtils';
import {
	validateAWB,
} from './CaptureHawbValidations'
import LoadingIndicator from '../LoadingIndicator';

const HAWBInputBox = ({
    t,
    error,
    setError,
    awbDetails,
    setAwbDetails,
    getHAWBDetails,
    setIsLoading,
    isLoading,
}) => {
    const { i18n } = useTranslation();
    const isJapanese = i18n.language === 'ja';
    const isRTL = i18n.language === 'ar' || i18n.dir() === 'rtl';

    const handleGoClick = () => {
        if (setIsLoading) setIsLoading(true);
        getHAWBDetails();
    };

    return (
        
        <div className="hawb-input-box">
            {isLoading ? <LoadingIndicator /> : null}
            <div className='form-row'>
                <div className='col-12'>
                     <h4 className={`hawb-input-heading mb-0 mt-0 ${isRTL ? 'rtl' : ''}`}>{t('COMMON.AWB_NUMBER')}</h4>
                </div>
            </div>
            <div className='portal-row d-flex justify-content-between hawb-input-row'>
                <div className='portal-col'>
                    <div className='portal-col'>
                    

                        <div className={`awb-combined-input-group ${isJapanese ? 'ja' : ''} ${hasError('awbPrefix', error) || hasError('masterDocumentNumber', error) ? 'red-border-bottom' : ''}`}>
                            <div className='awb-prefix-input-wrapper'>
                                <input
                                   id='awbPrefix'
                                name='awbPrefix'
                                type='text'
                                className='awb-prefix-input form-item-field'
                                value={awbDetails.shipmentPrefix}
                                maxLength='3'
                                onChange={(e) => {
                                    setAwbDetails({
                                        ...awbDetails,
                                        shipmentPrefix: e.target.value,
                                    })
                                }}
                                onBlur={(e) => {
                                    validateAWBPrefix(e.target.value, setError)
                                }}
                                aria-invalid={hasError('awbPrefix', error)}
                                onFocus={(e) => {
                                    removeError(e, setError)
                                }}
                                />
                                <label
                                    htmlFor='awbPrefix'
                                    className={`floating-label ${awbDetails.shipmentPrefix ? 'has-value' : ''}`}
                                >
                                    {t("COMMON.PREFIX")}
                                </label>
                            </div>
                            <span className="awb-vertical-separator" aria-hidden="true"></span>
                            <div className='awb-document-input-wrapper'>
                                <input
                                    id='masterDocumentNumber'
                                name='masterDocumentNumber'
                                type='text'
                                className='awb-document-input'
                                autoComplete='off'
                                maxLength='8'
                                value={awbDetails.masterDocumentNumber}
                                onChange={(e) => {
                                    if (e.target.value.length <= 8) {
                                        setAwbDetails({
                                            ...awbDetails,
                                            masterDocumentNumber: e.target.value,
                                        })
                                    }
                                }}
                                aria-invalid={hasError('masterDocumentNumber', error)}
                                onFocus={(evnt) => removeError(evnt, setError, error)}
                                onBlur={(e) => {
										validateAWB(
											e.target.value,
											'masterDocumentNumber',
											setError
										)
									}}
                                />
                                <label
                                    htmlFor='awbDocumentNo'
                                    className={`floating-label ${awbDetails.masterDocumentNumber ? 'has-value' : ''}`}
                                >
                                    {t("COMMON.AWB_NUMBER")}
                                </label>
                            </div>
                        </div>
                        <div className="form-item__error-container">
                        {(error && (error['awbPrefix'] || error['masterDocumentNumber'])) && (
                            <span className='form-item__error'>
                                {error['awbPrefix']
                                    ? t(error['awbPrefix'], { ns: 'errors' })
                                    : error['masterDocumentNumber']
                                        ? t(error['masterDocumentNumber'], { ns: 'errors' })
                                        : ''}
                            </span>
                        )}
                        </div>


                        {/* <div className='col-3 col-lg-3 pr-2 pb-3 pb-md-0 form-item form-item--text'>
                            <input
                                id='awbPrefix'
                                name='awbPrefix'
                                type='text'
                                className='form-item__field'
                                value={awbDetails.shipmentPrefix}
                                maxLength='3'
                                onChange={(e) => {
                                    setAwbDetails({
                                        ...awbDetails,
                                        shipmentPrefix: e.target.value,
                                    })
                                }}
                                onBlur={(e) => {
                                    validateAWBPrefix(e.target.value, setError)
                                }}
                                aria-invalid={hasError('awbPrefix', error)}
                                onFocus={(e) => {
                                    removeError(e, setError)
                                }}
                            />
                            <span className='form-item__error'>
                                {error && error['awbPrefix']
                                    ? t(error['awbPrefix'], { ns: 'errors' })
                                    : ''}
                            </span>
                        </div> */}

                        {/* <div className='col-9 col-lg-9 pl-1 form-item form-item--text'>
                            <input
                                id='masterDocumentNumber'
                                name='masterDocumentNumber'
                                type='text'
                                className='form-item__field'
                                placeholder='AWB number'
                                autoComplete='off'
                                maxLength='8'
                                value={awbDetails.masterDocumentNumber}
                                onChange={(e) => {
                                    if (e.target.value.length <= 8) {
                                        setAwbDetails({
                                            ...awbDetails,
                                            masterDocumentNumber: e.target.value,
                                        })
                                    }
                                }}
                                aria-invalid={hasError('masterDocumentNumber', error)}
                                onFocus={(evnt) => removeError(evnt, setError, error)}
                                onBlur={(e) => {
                                    // You can add a validateAWB function if needed
                                }}
                            />
                            <span className='form-item__error'>
                                {error && error['masterDocumentNumber']
                                    ? t(error['masterDocumentNumber'], { ns: 'errors' })
                                    : ''}
                            </span>
                        </div> */}

                    </div>
                </div>

                {/* Desktop view: right aligned */}
                <div className='captureAwb-Go d-none d-lg-flex justify-content-end'>
                    <button className='primary-button' onClick={handleGoClick}>
                        {t('COMMON.GO')}
                    </button>
                </div>
                {/* Mobile view: centered with padding */}
                <div className='col-12 d-flex d-lg-none justify-content-center px-3'>
                    <button className='primary-button w-100 mt-4' style={{ maxWidth: 220 }} onClick={handleGoClick}>
                        {t('COMMON.GO')}
                    </button>
                </div>
                {/* <div className='col-12 col-lg-2 go-button d-flex justify-content-end align-items-end'>
                    <button type='button' className='primary-button' onClick={getHAWBDetails}>
                        {t('COMMON.GO')}
                    </button>
                </div> */}
            </div>
        </div>
    );
};

export default HAWBInputBox;